import { typeAccount } from "../api/typeAccount";
export const getTypeAccountsActives = () => {
  return typeAccount.getActives().then(response => response);
};
